import axiosInstanceV2 from 'utils/InstanceAxios/InstanceAxiosV2';
import axiosInstance from 'utils/InstanceAxios/InstanceAxios';
import { Types } from '../reducers/users';
import * as serverRoutes from 'utils/consts/serverRoutes.js';
import { toast } from 'react-toastify';

//Synchronous

//Asynchronous
export const createUser = (userData, callback) => {
    return (dispatch) => {
        axiosInstanceV2.post(serverRoutes.Users.crud(), userData)
        .then((response) => {
            dispatch({
                type: Types.CREATE_USER,
                payload: response.data
            })
            callback(true)
        })
        .catch((err) => {
            callback(false, err?.response?.data?.error);
            console.log(err?.response?.data?.error)
        })
    }
}

export const updateUser = (username, userData, callback) => {
    return (dispatch) => {
        axiosInstanceV2.put(serverRoutes.Users.crud(`/${username}`), userData)
        .then((response) => {
            dispatch({
                type: Types.UPDATE_USER,
                payload: response.data
            });
            callback(true);
        })
        .catch((err) => {
            console.log(err?.response?.data);
            callback(false, err?.response?.data);
        });
    }
}

export const getUser = (username) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.get(serverRoutes.Users.crud(`/${username}`))
        .then((response) => {
            dispatch({
                type: Types.GET_USER,
                payload: response.data
            })
        })
        .catch((err) => {
            console.log(err)
            dispatch({
                type: Types.GET_USER,
                payload: null,
            })
        })
    }
}

export const getUsers = (page, limit, query, sort="", filter="", period=null, filters={}) => {
    // if (period && period.length) {
    //   period[0].setHours(0,0,0,0);
    //   period[1].setHours(23,59,59,999);
    // }
    return (dispatch) => {
        dispatch({
            type: Types.GET_USERS,
            payload: null,
        });
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.get(serverRoutes.Users.crud('', {page, limit, query, sort, filter, period, ...filters}))
        .then((response) => {
            dispatch({
                type: Types.GET_USERS,
                payload: response.data
            });
        })
        .catch((err) => {
            console.log(err)
            dispatch({
                type: Types.GET_USERS,
                payload: null,
            });
        })
    }
}

export const getTechnicalResponsibleUsers = (page, limit, query, sort="", filter="technical-responsible", period=null, filters={}) => {
    // if (period && period.length) {
    //   period[0].setHours(0,0,0,0);
    //   period[1].setHours(23,59,59,999);
    // }
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.get(serverRoutes.Users.crud('', {page, limit, query, sort, filter, period, ...filters}))
        .then((response) => {
            dispatch({
                type: Types.GET_TECHNICAL_RESPONSIBLE_USERS,
                payload: response.data
            });
        })
        .catch((err) => {
            console.log(err)
            dispatch({
                type: Types.GET_TECHNICAL_RESPONSIBLE_USERS,
                payload: []
            });
        })
    }
}

export const deleteUser = (username, callback) => {
    return (dispatch) => {
        axiosInstanceV2.delete(serverRoutes.Users.crud(`/${username}`))
        .then((response) => {
            dispatch({
                type: Types.DELETE_USER,
                payload: response.data
            });
            callback(true);
        })
        .catch((err) => {
            console.log(err)
            callback(false, err?.response?.data);
        })
    }
}

export const getAccessHistory = (username, page, limit, query, sort="") => {
  if (!username) {
    return () => {}
  }
    return dispatch => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.get(serverRoutes.Users.accessHistory(`/${username}`, {page, limit, query, sort}))
        .then((response) => {
            dispatch({
                type: Types.ACCESS_HISTORY,
                payload: response.data
            })
        })
        .catch((err) => {
            console.log(err);
        })
    }
}

export const forgotPassword = (username, callback) => {
    return () => {
        axiosInstance.post(serverRoutes.Users.forgotPassword, { username })
        .then(() => {
            toast.success("Um E-mail será enviado, caso o usuário esteja cadastrado.", { autoClose: 10000 });
            callback();
        })
        .catch((err) => {
            toast.error(err.response?.data?.error || err.response?.data || err.message, { autoClose: 10000 });
            callback();
        })
    }
}

export const renewUserAccount = (username, callback) => {
  return (dispatch) => {
    axiosInstance.get(serverRoutes.Users.renew(`/${username}`))
    .then((response) => {
        dispatch({
            type: Types.UPDATE_USER,
            payload: response.data
        });
        callback(true);
    })
    .catch((err) => {
        callback(false);
        console.log(err);
    });
  }
}

export const setPasswordStatus = (username, password, callback) => {
  return (dispatch) => {
      axiosInstance.put(serverRoutes.Users.setPasswordStatus, { username, password })
      .then((response) => {
          dispatch({
            type: Types.UPDATE_USER,
            payload: response.data
          });
          callback(true);
      })
      .catch((err) => {
        console.log(err);
        callback(false);
      })
  }
}

export const reactivateUserAccount = (username, callback) => {
  return (dispatch) => {
    axiosInstance.get(serverRoutes.Users.reactivate(`/${username}`))
    .then((response) => {
        dispatch({
            type: Types.UPDATE_USER,
            payload: response.data
        });
        callback(true);
    })
    .catch((err) => {
        callback(false);
        console.log(err);
    });
  }
}

export const saveTokenLog = (tokenViewer, tokenOwner, token) => {
  return () => {
      axiosInstance.post('/save-token-log', { tokenViewer, tokenOwner, token })
      .then(() => {
          console.log("TOKEN_LOG_SAVED")
      })
      .catch((err) => {
          console.log(err)
      })
  }
}
